
    <ion-header>
      <ion-toolbar>
        <ion-title>Clerk Login Test</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <div style="text-align: center; margin-top: 50px;">
        <h2>Clerk Authentication Test Page</h2>
        <p>Click the button below to test the Clerk login modal</p>
        <ion-button (click)="openClerkLogin()" size="large" style="margin-top: 30px;">
          Test Clerk Login
        </ion-button>
        
        <ion-button (click)="openClerkSignUp()" size="large" color="secondary" style="margin-top: 20px;">
          Test Clerk Sign Up
        </ion-button>
        
        <ion-button (click)="signOut()" size="large" color="danger" style="margin-top: 20px;">
          Sign Out / Clear Session
        </ion-button>
        
        <div style="margin-top: 30px;" *ngIf="currentUser">
          <h3>Current User:</h3>
          <p>{{ currentUser | json }}</p>
        </div>
        
        <div style="margin-top: 30px;" *ngIf="currentSession">
          <h3>Current Session:</h3>
          <p>{{ currentSession | json }}</p>
        </div>
      </div>
    </ion-content>
  